import React from "react";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import Vestigingen from "./Tabs/Vestigingen";
import Roles from "./Tabs/Roles";
import AuthProvider from "../../auth/AuthProvider";
import { formatTitle } from "../../../utils/formatting";
import ChildUsers from "./Tabs/ChildUsers";

function Form(props) {
  return (
    <AuthProvider prefix={"users"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          return formatTitle(this.pageTitle, model.email);
        }}
        defaultValues={{ is_master: 1 }}
        endPoint={"core/gebruikers"}
        key={props.match?.params?.id}
        objectsExcludedAsRelation={{ roles: true }}
        pageTitle={getTranslation("gebruikers.form.pageTitle", "Gebruiker")}
        parseInput={{
          totp_confirmed: () => false,
          roles: (response) => JSON.stringify(response.map((role) => role.name)),
          is_master: (response) => !response,
        }}
        parseOutput={{ totp_confirmed: (value, prevValue) => (value ? null : prevValue), is_master: (val) => !val }}
        rootRight={"gebruikers"}
        tabs={[
          {
            right: "algemeen",
            tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"gebruikers.form.tabs.algemeen"} />,
            tabContent: <Algemeen />,
          },
          {
            right: "vestigingen",
            tabButton: <TranslationWrapper tDefault={"Vestigingen"} tKey={"gebruikers.form.tabs.vestigingen"} />,
            tabContent: <Vestigingen />,
          },
          {
            tabButton: <TranslationWrapper tDefault={"Has access to users"} tKey={"Child Users"} />,
            permissionKey: "child_users",
            tabContent: <ChildUsers />,
          },
          {
            tabButton: <TranslationWrapper tKey={"Roles"} />,
            permissionKey: "roles",
            tabContent: <Roles />,
          },
        ]}
      />
    </AuthProvider>
  );
}

export default Form;
